module.exports = __webpack_public_path__ + "media/img/Fill-2-53cf4438.svg";